import { PlatformType } from '@src/container/type';
import { FS_ENV_ID } from '../constants';
import { useContext } from 'react';
import { AppContext } from '../provider/AppContext';
import { SEARCH_PARAM_OAUTH_CODE_V1 } from '@src/shared/constants';

export function useFsEnvIdQueryParam() {
  const params = new URL(document.location.toString()).searchParams;
  return params.get(FS_ENV_ID);
}

export function usePlatformQueryParam(): PlatformType {
  const params = new URL(document.location.toString()).searchParams;
  return params.get('platformType') as PlatformType;
}
export function useFsUrlQueryParam() {
  const params = new URL(document.location.toString()).searchParams;
  return params.get('fsUrl');
}
export function useTagUrlQueryParam() {
  const params = new URL(document.location.toString()).searchParams;
  return params.get('tagUrl');
}
export function useTagOAuthCodeV1QueryParam() {
  const params = new URL(document.location.toString()).searchParams;
  return params.get(SEARCH_PARAM_OAUTH_CODE_V1);
}

export function useAppContext() {
  return useContext(AppContext);
}

export function usePlatform(): PlatformType | undefined {
  const context = useAppContext();
  return context.state.platformType;
}

export function useIsFsPlatform() {
  return usePlatform() === 'FS';
}

export function useIsTagPlatform() {
  return usePlatform() === 'TAG';
}
